export enum constants {
  wrapperClassName = "mmd-wrapper",
  inlineClassName = "mmd-wrapper--inline",
  baseClassName = "mmd-picker",
  monthWrapperClassName = "mmd-picker__month-wrapper",
  rtlClassName = "mmd-picker--rtl",
  ltrClassName = "mmd-picker--ltr",

  // headers class name:
  headerClassName = "mmd-picker__header",
  arrowsClassName = "mmd-picker__arrows",
  arrowsRightClassName = "mmd-picker__arrows--right",
  arrowsLeftClassName = "mmd-picker__arrows--left",
  titleClassName = "mmd-picker__titles",
  titleMonthClassName = "mmd-picker__title-month",
  titleYearClassName = "mmd-picker__title-year",

  // body class name:
  bodyClassName = "mmd-picker__body",
  weeksClassName = "mmd-picker__weeks",
  weekItemClassName = "mmd-picker__week-item",
  daysClassName = "mmd-picker__days",
  dayItemClassName = "mmd-picker__day-item",
  selectedDayItemClassName = "mmd-picker__day-item--selected",
  inRangeDayItemClassName = "mmd-picker__day-item--in-range",
  todayClassName = "mmd-picker__day-item--today",
  disabledDayItemClassName = "mmd-picker__day-item--disabled",
  offsetDayItemClassName = "mmd-picker__day-item--offset",
  weekendDayItemClassName = "mmd-picker__day-item--weekend",

  // footer class name:
  footerClassName = "mmd-picker__footer",
}
